import { TermsEntity } from '@/entities';

import type { LangType, RequiredConsentItem } from '@/entities/terms/types';

/**
 * TRAD-3759 — 게이트(PrivateRoute)와 재동의 화면(/terms-agreement)이 같이 쓰는 «빠진 동의 목록».
 *
 * 🔴 TRAD-3777(davidyoon 2026-10-19 «권고안으로 진행», 에픽 TRAD-3773) — 하우스 룰(EULA)은 더 이상 로그인 게이트에서 묻지 않는다.
 * 3사 공통으로 «글·댓글을 쓸 때» 따로 묻는다(`features/terms/ui/HouseRuleGate.tsx` · `useHouseRuleGate`). 그래서 이 목록 = 서버
 * required-missing 그대로다. ~~required-missing + 하우스 룰 미동의 한 줄(결정 A)~~ ← 2026-10-18 결정 A, 이번에 철회.
 *
 * 실패하면 throw — 호출부(게이트)가 «막지 않음 + 로깅»으로 처리한다(G2). 종전엔 한쪽만 실패하면 다른 쪽(하우스 룰)으로 판정했는데,
 * 하우스 룰이 빠졌으니 그 분기도 없다.
 *
 * `_langType` 은 쿼리 키(query-options.ts)와 호출 모양을 유지하려고 남긴다 — 서버 목록은 로케일과 무관하다.
 */
export const fetchMissingConsents = async (_langType: LangType): Promise<RequiredConsentItem[]> => {
  const required = await TermsEntity.TermsRepository.getRequiredMissingConsents();
  return required?.items ?? [];
};
